var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.63515 11.189L3.8304 4.38052C3.39291 3.59765 3.17417 3.20621 3.21103 2.88573C3.2432 2.60611 3.3917 2.353 3.6201 2.18852C3.88188 2 4.33029 2 5.22711 2H7.46193C7.79523 2 7.96187 2 8.11135 2.04813C8.24362 2.09073 8.36556 2.16042 8.46939 2.25276C8.58674 2.35712 8.67132 2.5007 8.8405 2.78788L12.5001 9L16.1597 2.78788C16.3289 2.5007 16.4135 2.35712 16.5308 2.25276C16.6347 2.16042 16.7566 2.09073 16.8889 2.04813C17.0383 2 17.205 2 17.5383 2H19.7731C20.6699 2 21.1183 2 21.3801 2.18852C21.6085 2.353 21.757 2.60611 21.7892 2.88573C21.826 3.20621 21.6073 3.59765 21.1698 4.38052L17.3651 11.189M11.0001 14L12.5001 13V18M11.2501 18H13.7501M17.0963 10.9038C19.6347 13.4422 19.6347 17.5578 17.0963 20.0962C14.5579 22.6346 10.4423 22.6346 7.90391 20.0962C5.3655 17.5578 5.3655 13.4422 7.90391 10.9038C10.4423 8.3654 14.5579 8.3654 17.0963 10.9038Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardMedal);
export default __webpack_public_path__ + "static/media/awardMedal.47072aa53dd5535f3afb677677173ddb.svg";
export { ForwardRef as ReactComponent };